/**
 * Cashtag detection for post content.
 * Matches ticker-style cashtags like $SOL, $wif, $captcha — case-insensitive
 * because low-cap Solana tickers often ship mixed-case or lowercase forms.
 * Excludes $USDC (buying USDC with USDC is nonsensical).
 *
 * Uses whitespace / start-of-string boundary checks (no lookbehinds)
 * for Hermes compatibility — same strategy as LinkifiedText mentions.
 */

/** Matches $ticker cashtags (2–10 letters, any case). Boundary checks done manually. */
export const CASHTAG_REGEX = /\$([A-Za-z]{2,10})\b/g

export const EXCLUDED_TICKERS = new Set(["USDC"])

/**
 * Returns the first valid cashtag ticker from text (normalized to uppercase),
 * or null. Only matches when preceded by whitespace or start-of-string.
 */
export function extractFirstCashtag(text: string): string | null {
	CASHTAG_REGEX.lastIndex = 0
	for (const match of text.matchAll(CASHTAG_REGEX)) {
		const matchStart = match.index ?? 0
		// Must be at start of string or preceded by whitespace
		if (matchStart > 0 && !/\s/.test(text[matchStart - 1])) {
			continue
		}
		const ticker = match[1].toUpperCase()
		if (EXCLUDED_TICKERS.has(ticker)) {
			continue
		}
		return ticker
	}
	return null
}
